// export const baseUrl = 'http://192.168.3.16:8080/nation-web/'  // (国民通用)
// export const baseUrl = 'http://n.healthyoung.life'
// export const baseUrl = 'http://10.1.1.244:8002/haoyan-web'

// export const baseUrl = 'http://10.154.235.147:8001/nation-web/'
// export const baseUrl = 'http://192.168.101.186:8080/nation-web'
// export const baseUrl = 'http://192.168.1.105/nation-web'
// export const baseUrl = 'http://localhost:8090/nation-web/'  // 本地后端联调用(临时切换,勿提交)
export const baseUrl = 'https://nation.healthyoung.life/nation-web/'
export const ERR_OK = 200
export const pageSize = 20
export const pageSizes = [20, 40, 60, 80, 100]
// 联盟
export const one = './static/images/logoTwo.png'
export const head = './static/images/headTwo.png'



// WEBPACK FOOTER //
// ./src/common/api/api.js